/**
 * Nhãn danh mục BĐS tiếng Việt — map slug/name API sang tên hiển thị và từ khóa tìm kiếm.
 */

const CATEGORY_NAME_BY_SLUG = {
  apartment: 'Căn hộ',
  house: 'Nhà phố',
  villa: 'Biệt thự',
  land: 'Đất nền',
  office: 'Văn phòng',
  'shop-house': 'Nhà mặt tiền',
  store: 'Nhà mặt tiền',
};

const CATEGORY_NAME_BY_ENGLISH = {
  Apartment: 'Căn hộ',
  House: 'Nhà phố',
  Villa: 'Biệt thự',
  Land: 'Đất nền',
  Office: 'Văn phòng',
  'Shop House': 'Nhà mặt tiền',
};

/**
 * Lấy tên hiển thị danh mục (ưu tiên map slug/name).
 * @param {Object|null|undefined} category
 * @returns {string}
 */
export const getCategoryName = (category) => {
  if (!category) {
    return '';
  }

  if (category.slug && CATEGORY_NAME_BY_SLUG[String(category.slug).toLowerCase()]) {
    return CATEGORY_NAME_BY_SLUG[String(category.slug).toLowerCase()];
  }

  if (category.name && CATEGORY_NAME_BY_ENGLISH[category.name]) {
    return CATEGORY_NAME_BY_ENGLISH[category.name];
  }

  return category.name || '';
};

const CATEGORY_SEARCH_KEYWORD_BY_SLUG = {
  apartment: 'căn hộ',
  house: 'nhà phố',
  villa: 'biệt thự',
  land: 'đất nền',
  office: 'văn phòng',
  'shop-house': 'mặt tiền',
  store: 'mặt tiền',
};

/**
 * Từ khóa tìm kiếm theo danh mục (slug hoặc tên đã Việt hóa).
 * @param {Object|null|undefined} category
 * @returns {string}
 */
export const getCategorySearchKeyword = (category) => {
  if (!category) {
    return '';
  }

  const slug = String(category.slug || '').toLowerCase();

  if (slug && CATEGORY_SEARCH_KEYWORD_BY_SLUG[slug]) {
    return CATEGORY_SEARCH_KEYWORD_BY_SLUG[slug];
  }

  return getCategoryName(category).toLowerCase();
};
